import * as React from 'react';
import { Grid, withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { room, accessrule, dayMaps, temporaryConfig } from '../../../model/room';
// import { Buttons } from './Buttons';
import { styles } from '../styles';
import DeleteIconButton from '../../../ui-components/Button/DeleteIconButton';
import NumericField from '../../../ui-components/NumericField/NumericField';
import DatePicker from '../../../ui-components/DatePicker/DatePicker';
import { DayRow } from './components/DayRow';
import NewItemButton from '../../../ui-components/Button/NewItemButton';
import Dialog from '@material-ui/core/Dialog';
import { Calendar } from './components/Calendar';
import { TemporaryConfig } from './components/TemporaryConfig';
import TextField from '../../../ui-components/TextField/TextField';
import Button from '../../../ui-components/Button/Button';
import { callAccess } from '../../contacts/components/Detail/AccessDialog';
// import { webClientAddress } from '../../../model/access';

interface IProps extends StyledComponentProps {
    selected: string;
    changeAccessRule: (accessrule: accessrule) => void;
    accessrule: accessrule;
    room?: room;
    changeRoomInEdit: (room: room) => void;
}

const RoomAccessRule = (props: IProps) => {
    const [showCalendar, setShowCalendar] = React.useState<boolean>(false);
    const [showChooseNewConfig, setShowChooseNewConfig] = React.useState<boolean>(false);

    const handleTimeChange = (hours: number, minutes: number, day: string, field: string) => {
        let x = props.accessrule;
        if (x !== undefined) {
            if (!x[day])
                x[day] = {};
            x[day][field] = { hours: hours, minutes: minutes };
            props.changeAccessRule(x);
        }
    }
    const handleDurationChange = (duration: number, day: string) => {
        let x = props.accessrule;
        if (!x[day])
            x[day] = {};
        x[day]['duration'] = duration;
        props.changeAccessRule(x);
    }
    const handleCapacityChange = (capacity: number) => {
        let x = props.accessrule;

        x.capacity = capacity;
        props.changeAccessRule(x);
    }

    const handleStayingMinutesChange = (stayingMinutes: number) => {
        let x = props.room;

        x.stayingMinutes = stayingMinutes;
        props.changeRoomInEdit(x);
    }
    const handleIpChange = (ipAddress: any) => {
        // console.info(ipAddress)
        let x = props.room;
        x.ipAddress = ipAddress;
        props.changeRoomInEdit(x);
    }
    const handleRpiIpChange = (ipAddress: any) => {
        // console.info(ipAddress)
        let x = props.room;
        x.raspberrySetupIpAddress = ipAddress;
        props.changeRoomInEdit(x);
    }
    // const callLog = (ipAddress: any) => {
    //     console.info(ipAddress)
    //     var x = { ip: ipAddress };
    //     // var s = { sub: this.props.sub };
    //     // callAccess(this.state.ip, '/access', s).then(
    //     callAccess(ipAddress, '/log', 'POST', x).then(
    //         result => {
    //             console.info("RESULT!!!!!!!!!!!!!!!!!!!!")
    //             console.log(result);
    //         }
    //     );
    // }

    let wind: Window | null = null;

    React.useEffect(() => {
        window.addEventListener("message", getEvent);
        return () => window.removeEventListener("message", getEvent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getEvent = (event) => {
        // window.opener.postMessage({ type: "command", response: y }, "http://localhost:49379");
        if (event && event.data && event.data.type === 'command') {
            debugger;
            console.log("event", event.data)
            if (event.data.response !== undefined) {
                // var _accessAllowed = (event.data.response.status == "OK");
                // var _message = event.data.response.message;
            }
            if (wind) {
                wind.close();
            }
        }
    }
    
    const callChangeApi = (ipAddress: any) => {
        console.info(ipAddress)
        var body = { api: props.room.raspberrySetupIpAddress };
        wind = callAccess(ipAddress, '/changeapi', 'POST', body);
    }

    const callReboot = (ipAddress: any) => {
        console.info(ipAddress)
        var body = {};
        wind = callAccess(ipAddress, '/reboot', 'POST', body);
    }

    const callOpenvpn = (ipAddress: any) => {
        console.info(ipAddress)
        var body = {};
        wind = callAccess(ipAddress, '/openvpn', 'POST', body);
    }

    const callTest = (ipAddress: any) => {
        console.info(ipAddress)
        var body = {};
        wind = callAccess(ipAddress, '/test', 'POST', body);
    }

    const handleReservableToChange = (reservableTo: Date) => {
        let x = props.room;

        x.reservableTo = reservableTo;
        props.changeRoomInEdit(x);
    }

    const handleReservableFromChange = (reservableFrom: Date) => {
        let x = props.room;

        x.reservableFrom = reservableFrom;
        props.changeRoomInEdit(x);
    }

    const handleDateChange = (value: Date, i?: number) => {
        let x = props.accessrule;
        x.closingDays = x.closingDays || [];
        x.closingDays[i] = value;
        props.changeAccessRule(x);
    }
    const handleDateAdd = (value: Date) => {
        let x = props.accessrule;
        x.closingDays = x.closingDays || [];
        x.closingDays.push(value);
        props.changeAccessRule(x);
    }
    const removeClosingDate = (i: number) => {
        let x = props.accessrule;
        if (x.closingDays && x.closingDays.length >= i) {
            x.closingDays.splice(i, 1);
            props.changeAccessRule(x);
        }
    }
    const addTemporaryConfig = (value: temporaryConfig) => {
        let x = props.accessrule;
        x.temporaryConfig = x.temporaryConfig || [];
        x.temporaryConfig.push(value);
        props.changeAccessRule(x);
        setShowChooseNewConfig(false);
    }
    const removeTemporaryConfig = (i: number) => {
        let x = props.accessrule;
        if (x.temporaryConfig && x.temporaryConfig.length >= i) {
            x.temporaryConfig.splice(i, 1);
            props.changeAccessRule(x);
        }
    }
    const classes = props.classes;
    return (<>
        <Grid container className={props.classes.RoomDetailContainer}>
            {dayMaps.map((day, i) => (
                <div key={i} style={{ width: "100%" }}>
                    <DayRow
                        openingTime={props.accessrule && props.accessrule[day.field] && props.accessrule[day.field].openingTime}
                        closingTime={props.accessrule && props.accessrule[day.field] && props.accessrule[day.field].closingTime}
                        dayName={day.name}
                        duration={props.accessrule && props.accessrule[day.field] && props.accessrule[day.field].duration}
                        onClosingTimeChange={(h, m) => handleTimeChange(h, m, day.field, 'closingTime')}
                        onOpeningTimeChange={(h, m) => handleTimeChange(h, m, day.field, 'openingTime')}
                        onDurationChange={d => handleDurationChange(d, day.field)}
                    />
                </div>
            ))
            }
            <Grid container>
                <Grid item sm={3} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <NumericField
                        label="Capienza"
                        value={props.accessrule ? props.accessrule.capacity : 0}
                        onChange={d => handleCapacityChange(d)}
                    />
                </Grid>
                <Grid item sm={3} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <NumericField
                        label="Durata attività"
                        value={props.room ? props.room.stayingMinutes : 0}
                        onChange={d => handleStayingMinutesChange(d)}
                    />
                </Grid>
                <Grid item sm={3} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <DatePicker
                        key="reservation-room-from"
                        label="Inizio Validità"
                        value={props.room ? props.room.reservableFrom : undefined}
                        onChange={d => handleReservableFromChange(d)}
                    />
                </Grid>
                <Grid item sm={3} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <DatePicker
                        key="reservation-room-to"
                        label="Fine Validità"
                        value={props.room ? props.room.reservableTo : undefined}
                        onChange={d => handleReservableToChange(d)}
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={6} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <TextField
                        label="Setup Api - Web Address"
                        value={props.room && props.room.raspberrySetupIpAddress ? props.room.raspberrySetupIpAddress : "0.0.0.0"}
                        // onBlur={(d) => handleIpBlur(d)}
                        onChange={(text) => handleRpiIpChange(text)}
                    />
                </Grid>
                <Grid item sm={3} style={{ justifyContent: 'center', display: 'flex', position: 'relative', border: '1px solid #FFFFFF' }}>
                    <label style={{ backgroundColor: '#FF6627', height: 60, width: '100%', position: 'absolute', top: 0, textAlign: 'center', color: '#FFFFFF' }}></label>
                    <Button className={props.classes.ButtonTextSizeSmall} onClick={() => callChangeApi(props.room.ipAddress)}>Setup</Button>
                </Grid>
                <Grid item sm={3} style={{ justifyContent: 'center', display: 'flex', position: 'relative', border: '1px solid #FFFFFF' }}>
                    <label style={{ backgroundColor: '#FF6627', height: 60, width: '100%', position: 'absolute', top: 0, textAlign: 'center', color: '#FFFFFF' }}></label>
                    <Button className={props.classes.ButtonTextSizeSmall} onClick={() => callReboot(props.room.ipAddress)}>Reboot</Button>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={6} style={{ padding: "5px" }} className={classes.nameSurnameContainer}>
                    <TextField
                        label="Setup Varco - Ip"
                        value={props.room && props.room.ipAddress ? props.room.ipAddress : "0.0.0.0"}
                        onChange={(text) => handleIpChange(text)}
                    />
                </Grid>
                <Grid item sm={3} style={{ justifyContent: 'center', display: 'flex', position: 'relative', border: '1px solid #FFFFFF' }}>
                    <label style={{ backgroundColor: '#FF6627', height: 60, width: '100%', position: 'absolute', top: 0, textAlign: 'center', color: '#FFFFFF' }}></label>
                    <Button className={props.classes.ButtonTextSizeSmall} onClick={() => callTest(props.room.ipAddress)}>Test</Button>
                </Grid>
                <Grid item sm={3} style={{ justifyContent: 'center', display: 'flex', position: 'relative', border: '1px solid #FFFFFF' }}>
                    <label style={{ backgroundColor: '#FF6627', height: 60, width: '100%', position: 'absolute', top: 0, textAlign: 'center', color: '#FFFFFF' }}></label>
                    <Button className={props.classes.ButtonTextSizeSmall} onClick={() => callOpenvpn(props.room.ipAddress)}>Vpn</Button>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={12} className={props.classes.ClosingDaysTitle}>
                    <Grid item sm={6} className={props.classes.ClosingDaysLabel}>
                        <Typography variant='body1'>Giorni Chiusura</Typography>
                    </Grid>
                    <Grid item sm={3}>
                        <NewItemButton text='Nuova chiusura' onClick={() => setShowCalendar(true)} />
                    </Grid>
                    <Grid item sm={1}>
                        <></>
                    </Grid>
                    {/* { SETUP } */}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={12} className={props.classes.ClosingDaysListContainer}>
                    {props.accessrule && props.accessrule.closingDays && props.accessrule.closingDays.map((t, i) => {
                        return (
                            <Grid item sm={12} style={{ padding: "5px" }} className={props.classes.ClosingDayPickerContainer}>
                                <DatePicker
                                    key={`1${i}`}
                                    label="Chiusura"
                                    value={t}
                                    onChange={(e) => handleDateChange(e, i)}
                                />
                                <DeleteIconButton className={props.classes.ClosingDayDeleteIcon} onClick={() => removeClosingDate(i)} />
                            </Grid>)

                    })}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={12} className={props.classes.ClosingDaysTitle}>
                    <Grid item sm={6} className={props.classes.ClosingDaysLabel}>
                        <Typography variant='body1'>Orari ridotti</Typography>
                    </Grid>
                    <Grid item sm={3}>
                        <NewItemButton text='Orario ridotto' onClick={() => setShowChooseNewConfig(true)} />
                    </Grid>
                    <Grid item sm={1}>
                        <></>
                    </Grid>
                    {/* { REBOOT } */}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item sm={12} className={props.classes.ClosingDaysListContainer}>
                    {props.accessrule && props.accessrule.temporaryConfig && props.accessrule.temporaryConfig.map((t, i) => {
                        return (
                            <Grid item sm={12} style={{ padding: "5px" }} className={props.classes.ClosingDayPickerContainer}>
                                <DatePicker key={`temp-config-${i}`} disabled value={t.date} onChange={() => { }} />
                                <DeleteIconButton className={props.classes.ClosingDayDeleteIcon} onClick={() => removeTemporaryConfig(i)} />
                            </Grid>)

                    })}
                </Grid>
            </Grid>
        </Grid>
        <Dialog open={showCalendar} onClose={() => setShowCalendar(false)}>
            <Calendar onCancel={() => setShowCalendar(false)}
                onConfirm={dt => {
                    handleDateAdd(dt);
                    setShowCalendar(false);
                }} />
        </Dialog>
        <Dialog open={showChooseNewConfig} onClose={() => setShowChooseNewConfig(false)}>
            <TemporaryConfig onConfirm={addTemporaryConfig} onCancel={() => setShowChooseNewConfig(false)} />
        </Dialog>
    </>);

}

export default withStyles(styles)(RoomAccessRule)